// @flow
import UpdateMasterListModalContainer from './UpdateMasterListModalContainer'
export default UpdateMasterListModalContainer
